import { render, staticRenderFns } from "./projectChange.vue?vue&type=template&id=b5f86902&scoped=true&"
import script from "./projectChange.vue?vue&type=script&lang=js&"
export * from "./projectChange.vue?vue&type=script&lang=js&"
import style0 from "./projectChange.vue?vue&type=style&index=0&id=b5f86902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f86902",
  null
  
)

export default component.exports